
import { defineComponent, toRefs, ref, PropType, reactive } from 'vue'
import { useRouter, Router } from 'vue-router'

import { parseTime, compareTime } from '@/utils/filter/timer'

import { meeting_title } from '@/utils/constant'
import ButtonCom from '@/components/ButtonCom/index.vue'
import { IButtonOptions } from '@/typings/common'

interface IItem {
  MeetingID: string
  SignUpStartDate: string
  SignUpStopDate: string
  ChargeOrNot: boolean
  MeetingImageUrl: string
  MeetingName: string
}

const currDate = new Date().toString()
export default defineComponent({
  components: {
    ButtonCom
  },
  props: {
    direction: {
      type: String,
      default: 'right'
    },
    item: {
      type: Object as PropType<IItem>,
      default: () => {
        return ref({
          SignUpStartDate: currDate,
          SignUpStopDate: currDate,
          ChargeOrNot: true,
          MeetingName: '会议名异常',
          MeetingImageUrl: '/UploadFile/common/meeting-not404.png',
          MeetingID: ''
        })
      }
    }
  },
  setup(props) {
    const { item } = toRefs(props)
    const router: Router = useRouter()
    const {
      SignUpStartDate,
      SignUpStopDate,
      ChargeOrNot,
      MeetingImageUrl,
      MeetingName,
      MeetingID
    } = toRefs(item.value)
    const isStart = compareTime(currDate, SignUpStartDate.value)
    const isEnd = compareTime(currDate, SignUpStopDate.value)
    let text = ''
    let background = ''
    console.log('ChargeOrNot', ChargeOrNot.value)
    if (!isStart) {
      text = '报名未开始'
      background = '#126BFF'
    } else if (isEnd) {
      text = '报名已结束'
      background = '#FEA912'
    } else if (isStart && !isEnd) {
      text = '报名中'
      background = '#67c23a'
    }

    if (!ChargeOrNot.value) {
      text = '免费报名'
      background = '#f56c6c'
    }

    // 免费报名 报名未开始 报名中 报名已结束 ChargeOrNot 是否需要费用
    const btnOption = reactive<IButtonOptions>({
      width: 200,
      height: 42,
      background,
      text,
      color: '#fff'
    })

    const handleMeetingDetails = () => {
      router.push({
        name: 'meeting',
        query: {
          meetingName: MeetingName.value,
          MeetingID: MeetingID.value
        }
      })
    }
    return {
      meeting_title,
      SignUpStartDate: ref(parseTime(SignUpStartDate.value, '{y}-{m}-{d}')),
      SignUpStopDate: ref(parseTime(SignUpStopDate.value, '{y}-{m}-{d}')),
      MeetingImageUrl:
        process.env.VUE_APP_BASE_URL +
        (MeetingImageUrl?.value || '/UploadFile/common/meeting-not404.png'),
      btnOption,
      handleMeetingDetails
    }
  }
})
